import * as React from 'react';
import Popup from './Popup'
import InputPopup from './InputPopup'
import BasicPopup from './BasicPopup'
import  { connect } from 'react-redux';

interface Props {
  popup: any;
}

class PopupContainer extends React.Component<Props, {}> {
  render() {
    if (!this.props.popup)
      return null
    return (this.props.popup.type === 'component' ? (
      <Popup {...this.props.popup.settings}>
        { this.props.popup.component() }
      </Popup>
    ) : this.props.popup.type === 'info' ? (
      <BasicPopup {...this.props.popup.settings} />
    ) : this.props.popup.type === 'input' ? (
      <InputPopup {...this.props.popup.settings} />
    ) : (null));
  }
}

const mapStateToProps = (state: any) => ({
  popup: state.popupReducer.popup,
});

export default connect(mapStateToProps)(PopupContainer);
